import { Segment, SegmentedButton, Text } from '~/shared/ui'

export function YesNoField({
  label,
  value,
  onChange,
}: {
  label: string
  value: boolean | null
  onChange: (value: boolean) => void
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <Text appearance="SUBTITLE2">
        {label}
        <span className="text-error-main">*</span>
      </Text>
      <SegmentedButton size="small">
        <Segment
          checked={value === true}
          onClick={() => onChange(true)}
        >
          Yes
        </Segment>
        <Segment
          checked={value === false}
          onClick={() => onChange(false)}
        >
          No
        </Segment>
      </SegmentedButton>
    </div>
  )
}
